module.exports = __webpack_public_path__ + "img/22_51.6d4d5ddf.png";